import React from 'react';

export default function PlayerEliminatedModal({ eliminatedBy, onSpectate, onReturnHome, isBankruptcy }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.9)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)',
        borderRadius: '20px',
        padding: '40px',
        maxWidth: '500px',
        width: '90%',
        boxShadow: '0 20px 40px rgba(0,0,0,0.5)',
        border: '3px solid #FF4444',
        textAlign: 'center'
      }}>
        {/* Elimination Icon */}
        <div style={{
          fontSize: '4em',
          marginBottom: '10px'
        }}>{isBankruptcy ? '💸' : '💀'}</div>

        {/* Elimination Announcement */}
        <h1 style={{
          color: '#FF4444',
          fontSize: '2.5em',
          marginBottom: '10px',
          textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
        }}>
          {isBankruptcy ? 'Bankruptcy!' : "You've Been Eliminated!"}
        </h1>

        <h2 style={{
          color: '#FFFFFF',
          fontSize: '1.3em',
          marginBottom: '30px',
          textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
        }}>
          {isBankruptcy ? 'Your budget reached -$100,000' : `Taken over by ${eliminatedBy}`}
        </h2>

        <div style={{
          color: '#AAAAAA',
          fontSize: '1em',
          marginBottom: '30px',
          lineHeight: '1.6'
        }}>
          {isBankruptcy ? 
            'All your assets have been liquidated.' : 
            'All your assets have been transferred.'
          }
          <br />
          You can continue watching the game or return home.
        </div>

        {/* Action Buttons */}
        <div style={{
          display: 'flex',
          gap: '15px',
          justifyContent: 'center',
          flexWrap: 'wrap'
        }}>
          <button
            onClick={onSpectate}
            style={{
              backgroundColor: '#2196F3',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '1.1em',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              minWidth: '150px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#1976D2'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#2196F3'}
          >
            👁️ Spectate
          </button>
          
          <button
            onClick={onReturnHome}
            style={{
              backgroundColor: '#FF6B6B',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              padding: '12px 24px',
              fontSize: '1.1em',
              fontWeight: 'bold',
              cursor: 'pointer',
              transition: 'background-color 0.3s',
              minWidth: '150px'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#FF5252'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#FF6B6B'}
          >
            🏠 Return Home
          </button>
        </div>
      </div>
    </div>
  );
}
